const testUa = (r: RegExp): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return r.test(ua) ? true : false;
};

export default testUa;
